// Any -> Bool
// True if the given value is a string representing a numerical value
exports.isNumeric = (str) => {
  return typeof str == "string"
    && !isNaN(str)
    && !isNaN(parseFloat(str))
}
